module.exports = __webpack_public_path__ + "img/d7c5cea.png";